// extracted by mini-css-extract-plugin
export default {"container":"styles_container__71lvd","content":"styles_content__-KSS3"};